export function isSeleniumRunning() {
  return document.cookie.includes('hs_selenium');
}
export function isJasmineRunning() {
  return window && 'jasmineRequire' in window;
}